import { InfraResponse, SuccessInfraResponse } from "~/api/_common/InfraResponse"
import { defineFetcher } from "~/api/_common/defineFetcher"
import { GET } from "~/api/_common/http"

import { AchievementsSkill } from "./_get-types/AchievementsSkill"
import { BasicInfo } from "./_get-types/BasicInfo"
import { BasicSkillEvaluationResult } from "./_get-types/BasicSkill"
import { Company } from "./_get-types/Company"
import { Evaluation, BasicSkill } from "./_get-types/Evaluation"
import { Experience } from "./_get-types/Experience"
import { Info } from "./_get-types/Info"
import { InternshipExperience } from "./_get-types/InternshipExperience"
import { JobHunting } from "./_get-types/JobHunting"
import { SelfPr } from "./_get-types/SelfPr"

type GetStudentProfile = InfraResponse<GetStudentProfileData>

export type GetStudentProfileData = {
  basic_info: BasicInfo
  self_pr: SelfPr
  experiences: Experience
  achievements_skills: AchievementsSkill
  job_hunting: JobHunting
  internship_experiences: InternshipExperience
  info: Info
}

export const fetchGetStudentProfile = defineFetcher((): Promise<GetStudentProfile> => {
  return GET("/student/profile")
})

export const fetchGetEvalutionStudentProfile = defineFetcher((): Promise<Evaluation> => {
  return GET("/student/user_request/evaluation")
})

export const fetchGetInternCompanies = defineFetcher((): Promise<Company[] | []> => {
  return GET("/student/intern-company")
})

export const fetchGetBasicSkills = defineFetcher((): Promise<BasicSkill[]> => {
  return GET("/basic_skills")
})

export const fetchGetBasicSkillEvaluationNotifies = defineFetcher(
  (): Promise<SuccessInfraResponse<BasicSkillEvaluationResult[]>> => {
    return GET("/student/notifications/basic-skills")
  }
)
